import { Directive } from 'vue';

const cleanTextDirective: Directive = {
  beforeMount(el) {
    if (typeof el.innerText === 'string') {
      el.innerText = el.textContent.replace(/[\r\n]+/g, ' ').replace(/\\r\\n/g, ' ');
    }
  },
  updated(el) {
    if (typeof el.innerText === 'string') {
      el.innerText = el.textContent.replace(/[\r\n]+/g, ' ').replace(/\\r\\n/g, ' ');
    }
  },
};

export default cleanTextDirective;
